export interface ICalendarText {
    emptyEventsMessage: string;
    emptyMonthMessage: string;
};

export const emptyCalendarTextInterface: ICalendarText = {
    emptyEventsMessage: '',
    emptyMonthMessage: ''
};


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/classes/calendar-text.ts